import * as Dialog from '@radix-ui/react-dialog';

import { Button } from '@/components/button';
import { cn } from '@/utils/cn';

import Icons from './Icons';

interface DrawerProps {
  isOpen: boolean;
  title: string;
  buttonTitle: string;
  secondButton?: React.ReactNode;
  children: React.ReactNode;
  close: VoidFunction;
}

const Drawer: React.FC<DrawerProps> = ({ isOpen, title, buttonTitle, secondButton = null, children, close }: DrawerProps) => {
  return (
    <Dialog.Root open={isOpen} onOpenChange={close}>
      <Dialog.Portal>
        <Dialog.Overlay className='fixed inset-0 bg-black/50 animate-fade-in z-50' />
        <Dialog.Content
          className={cn(
            'fixed bottom-0 right-0 flex flex-col h-full w-full lg:w-[530px] lg:border-l-2 bg-surface-primary border-border-primary animate-fade-in z-50',
          )}
        >
          <Dialog.Description className='hidden'>{title}</Dialog.Description>
          <div className='flex items-center justify-between px-4 lg:px-8 py-6 border-b lg:border-b-2 border-border-primary'>
            <div />
            <Dialog.Title className='text-xl lg:text-2xl text-text-primary tracking-02em '>{title}</Dialog.Title>
            <Button variant='tertiary' onClick={close}>
              <Icons.Close />
            </Button>
          </div>
          <div className='flex flex-1 flex-col px-4 lg:px-8 py-4 lg:py-6'>{children}</div>
          <div className='flex flex-col lg:flex-row shrink-0 items-center justify-center gap-3 lg:gap-6 w-full py-5 px-6 lg:px-20 border-t lg:border-t-2 border-border-primary bg-surface-primary'>
            <Button onClick={close} className={cn('!w-full', secondButton ? '' : 'lg:!w-fit')}>
              {buttonTitle}
            </Button>
            {secondButton}
          </div>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
};

export default Drawer;
